import React, { forwardRef, useCallback } from 'react';
import PropTypes from 'prop-types';

import { Tracking } from 'bdvp-tracking';

import Carousel from '../../Carousel';
import RowHeading from '../../RowHeading';

import { CarouselRowType } from '../../../utils/constants';

import { PARTIAL_VISIBILITY_GUTTER, LAYOUT_ITEMS } from './constants';
import Card from './Card';

const carouselType = CarouselRowType.CATEGORY_V1;

const CategoryRow = forwardRef((props, ref) => {

    const {
        categories,
        title,
        loading,
        rank,
        ...otherProps
    } = props;

    const onAfterChangeHandler = useCallback((isScrollLeft) => {

        Tracking.trackCarouselScroll({
            carouselRank: rank,
            carouselTitle: title,
            isScrollLeft,
            carouselType,
        });

    }, [
        rank,
        title,
    ]);

    const onItemClickHandler = useCallback((event, category, index) => {

        Tracking.trackCarouselOnItemClick({
            carouselRank: rank,
            carouselTitle: title,
            index,
            id: category,
            carouselType,
        });

    }, [
        rank,
        title,
    ]);

    const renderItem = useCallback(({
        title: category, imageTemplateUrl, count, link,
    }, loading, index = 0) => (
        <Card
            loading={loading}
            index={index}
            category={category}
            imageTemplateUrl={imageTemplateUrl}
            count={count}
            link={link}
            onClick={onItemClickHandler}
        />
    ), [onItemClickHandler]);

    if (categories.length === 0 && !loading) {

        return null;

    }

    return (
        <div ref={ref} {...otherProps}>
            <RowHeading
                loading={loading}
                text={title}
                enableLeftRightMargin
            />
            <Carousel
                isLoading={loading}
                list={categories}
                renderItem={renderItem}
                onAfterChange={onAfterChangeHandler}
                partialVisibilityGutter={PARTIAL_VISIBILITY_GUTTER}
                layoutItems={LAYOUT_ITEMS}
            />
        </div>
    );

});

CategoryRow.propTypes = {
    loading: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    rank: PropTypes.number.isRequired,
    categories: PropTypes.arrayOf(
        PropTypes.shape({
            imageTemplateUrl: PropTypes.string.isRequired,
            count: PropTypes.number,
            title: PropTypes.string.isRequired,
            link: PropTypes.string.isRequired,
        })
    ).isRequired,
};

export default CategoryRow;
